export default {
  data() {
    return {
      iva_cliente: "",
      menu_filtro: false,
      valore_filtro: -1,
      filtro_pianificato: false,
      filtro_consegne: false,
    };
  },
  computed: {
    ordini_attivi() {
      return this.$store.getters.get_ordini_attivi
        .filter(
          (ordine) =>
            ordine.stato == this.valore_filtro || this.valore_filtro == -1
        )
        .filter(
          (ordine) =>
            !this.filtro_pianificato ||
            (!ordine.consegna_programmata && ordine.ritiro_cod == 1)
        );
    },
    ordini_attivi_consegne() {
      const ordini = this.ordini_attivi;
      const gruppi = {};
      ordini.forEach((ordine) => {
        if (!ordine.consegna_programmata) return; // SCARTA ordini senza consegna
        const key = ordine.consegna_programmata;
        if (!gruppi[key]) {
          gruppi[key] = [];
        }
        gruppi[key].push(ordine);
      });
      return Object.keys(gruppi).map((n_consegna) => ({
        n_consegna,
        ordini: gruppi[n_consegna],
      }));
    },
    ordini_evasi() {
      return this.$store.getters.get_ordini_evasi;
    },
    clienti() {
      return this.$store.getters.get_clienti;
    },
  },
  methods: {
    ricerca() {
      if (!this.iva_cliente) {
        this.$store.dispatch("fetch_ordini_evasi");
      } else {
        this.$store.dispatch("ricerca_ordine_server", {
          iva: this.iva_cliente,
        });
      }
    },
    get_consegna(id_consegna) {
      return this.$store.getters.get_consegna_by_id(id_consegna);
    },
  },
};
